module.exports = __webpack_public_path__ + "static/google-7f181bb1be432c6fcbcc14572e7eadec.svg";